// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_Mke","cls2":"ReferenceCard-cls2_rub ReferenceCard-cls1_Mke"};